import { Grid } from '@backstage/ui';
import { useCloudResourcesContext } from '../../Providers';
import styles from '../../resources-page.module.css';

const FAILED_SEVERITIES = ['Critical', 'High', 'Medium', 'Low'];

/**
 * Stat strip of the resources tab: totals over the currently filtered
 * resources, styled after the mockup (uppercase label, large tabular
 * number).
 */
export function ResourceStatCards() {
  const { cloudResources, failedRulesByResource, hasAccountFilter } =
    useCloudResourcesContext();

  const services = new Set(
    cloudResources.map(resource => resource.spec.service),
  );
  const regions = new Set(cloudResources.map(resource => resource.spec.region));
  const accounts = new Set(
    cloudResources.map(resource => resource.spec.account),
  );

  let failedChecks = 0;
  let resourcesWithFailures = 0;
  for (const resource of cloudResources) {
    const failed = (failedRulesByResource[resource.metadata.name] ?? []).filter(
      failedRule => FAILED_SEVERITIES.includes(failedRule.severity),
    );
    if (failed.length > 0) {
      failedChecks += failed.length;
      resourcesWithFailures += 1;
    }
  }

  // Project mode gains the Accounts stat (five cards on the strip).
  return (
    <Grid.Root columns="12" gap="3">
      <Grid.Item colSpan={{ xs: '12', sm: '6', md: hasAccountFilter ? '2' : '3' }}>
        <div className={styles.stat}>
          <span className={styles.statLabel}>Resources</span>
          <span className={styles.statValue}>{cloudResources.length}</span>
        </div>
      </Grid.Item>
      {hasAccountFilter && (
        <Grid.Item colSpan={{ xs: '12', sm: '6', md: '2' }}>
          <div className={styles.stat}>
            <span className={styles.statLabel}>Accounts</span>
            <span className={styles.statValue}>{accounts.size}</span>
          </div>
        </Grid.Item>
      )}
      <Grid.Item colSpan={{ xs: '12', sm: '6', md: hasAccountFilter ? '2' : '3' }}>
        <div className={styles.stat}>
          <span className={styles.statLabel}>Services</span>
          <span className={styles.statValue}>{services.size}</span>
        </div>
      </Grid.Item>
      <Grid.Item colSpan={{ xs: '12', sm: '6', md: hasAccountFilter ? '2' : '3' }}>
        <div className={styles.stat}>
          <span className={styles.statLabel}>Regions</span>
          <span className={styles.statValue}>{regions.size}</span>
        </div>
      </Grid.Item>
      <Grid.Item colSpan={{ xs: '12', sm: '6', md: hasAccountFilter ? '4' : '3' }}>
        <div className={styles.stat}>
          <span className={styles.statLabel}>Failed compliance checks</span>
          <span className={styles.statValue}>
            {failedChecks}
            {failedChecks > 0 && (
              <small>
                on {resourcesWithFailures}{' '}
                {resourcesWithFailures === 1 ? 'resource' : 'resources'}
              </small>
            )}
          </span>
        </div>
      </Grid.Item>
    </Grid.Root>
  );
}
